/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  $(".ProductList").find(".Grid__Cell").each(function(){    
  $(this).find(".product_variant select").change(function() {
    var selectedValue = $(this).val();
    console.log($(this).val())
    $(this).closest(".Grid__Cell").find(".ad_to_cart_coll").attr("data-var_id",selectedValue);
  });
  $(this).find('.ad_to_cart_coll').click(function(){
    var ID = $(this).attr("data-var_id");
    addItemToCart( ID, 1);
    $('.cart_dr').trigger( "click" );
  });
  });
  $('.Drawer__Close').click(function(){
    $("#sidebar-cart").attr("aria-hidden", true);
  });
  
  $(".ProductForm__option_select").chosen({width: "100%"});
  
});
function addItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      $("#sidebar-cart").attr("aria-hidden", false);
    }   
  }); 
}

$(document).ready(function(){
  var clicked = 0;
  $('.SelectButton').click(function(){
    clicked++;
    var isEven = function(someNumber) {
        return (someNumber % 2 === 0) ? true : false;
    };
     if (isEven(clicked) === false) {
      $(this).attr("aria-expanded",true);
       $("#header-locale-popover-2").attr('aria-hidden',false);
        $("#header-locale-popover-2").addClass("Popover--noWrap Popover--positionBottom Popover--alignCenter");
    }
    else{
      $(this).attr("aria-expanded",false);
      $("#header-locale-popover-2").attr('aria-hidden',true);
      $("#header-locale-popover-2").removeClass("Popover--noWrap Popover--positionBottom Popover--alignCenter");
    }
  });
});
  